var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGavel24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24,
    x: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 20,
    transform: "matrix(0.7075 -0.7067 0.7067 0.7075 -5.6854 13.7194)",
    width: 4,
    x: 11.73,
    y: 3.73
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 0.3157 11.246)",
    width: 4,
    x: 11.73,
    y: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.1722 7.7256)",
    width: 4,
    x: 3.24,
    y: 9.73
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 12,
    x: 1,
    y: 21
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGavel24Px);
export default __webpack_public_path__ + "static/media/gavel-24px.808cdbd142d0425e46217a99aa760dac.svg";
export { ForwardRef as ReactComponent };